class Listbox {

    constructor(element) {

        this.listbox = element;

        this.button = element.querySelector(".list-box__button");
        
        this.init();

    }

    toggleButtonClicked(event) {
        
        let currentAriaExpanded = event.target.getAttribute("aria-expanded");

        if (currentAriaExpanded === "false") {

            this.openDropdownMenu();

        } else {

            this.closeDropdownMenu();

        }

    }

    openDropdownMenu() {
        
        this.button.setAttribute("aria-expanded", "true");

    }

    closeDropdownMenu() {

        this.button.setAttribute("aria-expanded", "false");

    }

    documentClicked(event) {

        let clickedElement = event.target;
        
        if (!this.listbox.contains(clickedElement)) {
            this.closeDropdownMenu();
        }

    }
    
    init() {

        // Bind click event to button
        this.button.addEventListener("click", this.toggleButtonClicked.bind(this));

        document.addEventListener("click", this.documentClicked.bind(this));
        
    }

}

document.addEventListener("DOMContentLoaded", function () {

    let elListboxes = document.querySelectorAll(".list-box");

    if (elListboxes.length) {
        
        elListboxes.forEach(elListbox => new Listbox(elListbox));

    }

});

